import type { State } from "../../../useFormState/types/states";

type Input = State & {
  keyword: string;
};
type IsInputAsLeastOne = (input: Input) => boolean;

export const isInputAsLeastOne: IsInputAsLeastOne = (input) => {
  const { availabilityStatus, endDate, eventType, keyword, startDate } = input;

  return [
    endDate !== undefined,
    eventType.checkboxData.some(({ isChecked }) => isChecked),
    availabilityStatus.checkboxData.some(({ isChecked }) => isChecked),
    keyword !== "",
    startDate !== undefined,
  ].some(Boolean);
};
